import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { isPlatformBrowser, Location } from '@angular/common';
import { ToastService } from '../../services/toast/toast.service';
export interface ModalState {
  isOpen: boolean;
  modalId: string;
  dialogRef?: MatDialogRef<any>;
}

@Injectable({
  providedIn: 'root',
})
export class PopStateService {
  private popStateListener?: (event: PopStateEvent) => void;
  private isDialogOpen = false;
  private isRootRoute = false;
  private hasInitialHistoryEntry = false;
  isBrowser: boolean;

  constructor(
    private toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  createInitialHistoryEntry(route: string): void {
    if (!this.hasInitialHistoryEntry && this.isBrowser) {
      // Add a dummy history entry to prevent going back beyond root
      history.pushState({ isRootEntry: true, preventBack: true }, '', route);
      this.hasInitialHistoryEntry = true;
    }
  }

  /**
   * Sets up back button prevention specifically for root route
   */
  setupRootRouteBackPrevention(route: string): void {
    if (!this.isBrowser || this.popStateListener) return;

    this.popStateListener = (event: PopStateEvent) => {
      // If dialog is open and we're on root route, prevent navigation
      if (this.isDialogOpen && this.isRootRoute) {
        // Stay on the current page by pushing the same state again
        history.pushState(
          {
            preventBack: true,
            dialogOpen: true,
            isRootEntry: true,
          },
          '',
          route
        );

        // Show user feedback
        this.showBackButtonWarning();
      }
    };

    window.addEventListener('popstate', this.popStateListener);
  }
  /**
   * Show warning when user tries to navigate back
   */
  showBackButtonWarning(): void {
    // Use your existing toast service and translations
    const message =
      'Please complete the communication preferences to continue.';

    this.toastService.showWarning(message);
  }
  /**
   * Cleanup function for dialog navigation prevention
   */
  cleanupDialogNavigation(route: string): void {
    this.isDialogOpen = false;

    // Remove popstate listener
    if (this.popStateListener) {
      window.removeEventListener('popstate', this.popStateListener);
      this.popStateListener = undefined;
    }

    // Clean up URL if we added hash for dialog
    if (this.isBrowser && location.hash === '#communication-preferences') {
      // Remove the hash and go back to clean root URL
      history.replaceState({ isRootEntry: true }, '', route);
    }
  }
}
